var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8L16.1 9.4L17.7 11H9.5V13H17.7L16.1 14.6L17.5 16L21.5 12L17.5 8ZM5.5 5H12.5V3H5.5C4.4 3 3.5 3.9 3.5 5V19C3.5 20.1 4.4 21 5.5 21H12.5V19H5.5V5Z",
    fill: "#544C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiLogout);
export default __webpack_public_path__ + "static/media/mdi_logout.237d4330e7960084bc9de6d8b68f0d39.svg";
export { ForwardRef as ReactComponent };